module.exports = __webpack_public_path__ + "static/img/produto_g.262e190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/guarana/produto_g.png
// module id = VZMK
// module chunks = 0